/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Plugins
import { registerPlugins } from '@/plugins';

// Components
import App from './App.vue';

// Composables
import { createApp } from 'vue';

// Styles
import 'unfonts.css';

// Fabric text-decoration patch (side effect only)
import '@/helpers/fabricTextDecorationPatch';

import '@/helpers/fabricImageSmoothingPatch';

import '@/helpers/fabricGraphemeSplitPatch';

import '@/helpers/fabricImageBitmapPatch';

// Fabric effects patch: layer blur, background blur, fill opacity (side effect only)
// loaded before the scaled-away patch so an object scaled to nothing skips its blur work too
import '@/helpers/fabricEffectsPatch';

import '@/helpers/fabricScaledAwayPatch';

import '@/helpers/fabricClipLayerPatch';

import '@/helpers/fabricBackingScalePatch';

import { loadFontAccess } from '@/services/font/fontAccess';

/**
 * Fabric: cap retina backing-store at 2x. On 3x phones the default
 * triples both axes (9x pixel work) for negligible visual gain.
 */
import { config as fabricConfig } from 'fabric';

fabricConfig.devicePixelRatio = Math.min(window.devicePixelRatio || 1, 2);

// fetched on first use they land after the editor's first layout and the whole page lays out again
for (const font of [
  '400 1em "Google Sans"',
  '500 1em "Google Sans"',
  '700 1em "Google Sans"',
  '1em "Material Symbols Outlined"'
]) {
  document.fonts.load(font).catch(() => undefined);
}

const app = createApp(App);

registerPlugins(app);

/**
 * Font visibility rules. Started here rather than awaited, so app startup is
 * never blocked on the CDN - the font picker reads the rules reactively once
 * they arrive, and shows every font if they never do.
 */
loadFontAccess();

app.mount('#app');
